import Link from 'next/link';
import { signOut } from 'next-auth/react';

const handleLogout = async () => {
  await signOut({ callbackUrl: '/' });
};

export default function AdminMenu({ onLinkClick }) {
  const adminLinks = [
    {
      href: "/dashboard/admin",
      label: "Dashboard",
      desc: "Overview & metrics",
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
      )
    },
    {
      href: "/dashboard/admin/users",
      label: "Users",
      desc: "Client accounts",
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      )
    },
    {
      href: "/dashboard/admin/programs",
      label: "Programs",
      desc: "Premium offerings",
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      )
    },
    {
      href: "/dashboard/admin/enquiries",
      label: "Leads & Enquiries",
      desc: "Sales pipeline",
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
        </svg>
      )
    },
    {
      href: "/dashboard/admin/contacts",
      label: "Contact Inquiries",
      desc: "Direct support",
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      href: "/dashboard/admin/newsletter",
      label: "Newsletter",
      desc: "Email updates",
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
        </svg>
      )
    },
  ];

  return (
    <nav className='flex flex-col py-1'>
      {adminLinks.map((link, index) => (
        <Link
          key={index}
          href={link.href}
          className="flex items-center gap-4 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors group border-b border-gray-50 last:border-0"
          onClick={onLinkClick}
        >
          <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center text-gray-300 group-hover:bg-brand-primary/10 group-hover:text-brand-primary transition-all">
            {link.icon}
          </div>
          <div className="flex flex-col">
            <span className="font-bold text-brand-dark group-hover:text-brand-primary transition-colors">
              {link.label}
            </span>
            <span className="text-[10px] text-gray-300 uppercase font-black tracking-tight">
              {link.desc}
            </span>
          </div>
        </Link>
      ))}
      <button
        onClick={handleLogout}
        className="flex items-center gap-4 w-full text-left px-4 py-3 text-sm text-red-500 hover:bg-red-50 transition-colors group mt-1"
      >
        <div className="w-8 h-8 rounded-lg bg-red-50 flex items-center justify-center text-red-300 group-hover:bg-red-500 group-hover:text-white transition-all">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
        </div>
        <span className="font-bold">Logout system</span>
      </button>
    </nav>
  );
}
